import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {FieldArray} from "formik";
import moment from "moment";
const DateTimePicker = ({name,selectDate,formik,label,...rest}) => {
    return (
        <DatePicker
            className="acc__input-lg"
            selected={selectDate}
            onChange={(date) => formik.setFieldValue(name,date)}
            timeInputLabel="Time:"
            dateFormat="dd/MM/yyyy h:mm aa"
            name={name}
            isClearable
            placeholderText={label}
            showTimeInput

            minDate={moment().add(1,'minute').toDate()}
        />
    )
}

export default DateTimePicker;
